var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 51 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321317650"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_upward_alt",
    d: "M29.1667 3.75L29.1667 40.4833L42.3667 27.2833L47.5 32.4167L25.5 54.4167L3.5 32.4167L8.63333 27.2833L21.8333 40.4833L21.8333 3.75L29.1667 3.75Z",
    fill: "url(#paint0_linear_250_1349)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_1349",
    x1: 25.5,
    y1: 57.167,
    x2: 25.5,
    y2: 6.66699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B1DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C43E8",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.ba5dbcfc300cc9cdcb961e57db1630d5.svg";
export { ForwardRef as ReactComponent };